export default __webpack_public_path__ + "static/B0061-5e98868eb6a75c858dfadb7fa6d39672.png";